import { render } from "./TestCard.vue?vue&type=template&id=3c4058b0&scoped=true"
import script from "./TestCard.vue?vue&type=script&lang=js"
export * from "./TestCard.vue?vue&type=script&lang=js"

import "./TestCard.vue?vue&type=style&index=0&id=3c4058b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c4058b0"]])

export default __exports__